import "core-js/modules/es.promise.finally.js";
import e, { useEffect as n, forwardRef as t, createRef as o, useState as r } from "react";
function l() {
  return l = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, l.apply(this, arguments);
}
const c = () => "undefined" != typeof window && !!window.HTMLDialogElement;
let d = 0;
const a = () => "undefined" != typeof document && document.head,
  i = t((t, o) => {
    const {
      children: r,
      open: i,
      _rd: s,
      onCancel: u,
      onClose: m,
      _md: p,
      ...f
    } = t;
    return n(() => {
      if (a() && !c()) {
        if (d <= 0) {
          const e = document.createElement("style");
          e.innerHTML = "dialog:not([open]){display: none;}", e.id = "_rdp", document.head.appendChild(e);
        }
        return d++, () => {
          if (d--, !a() || d > 0) return;
          const e = document.getElementById("_rdp");
          e && document.head.removeChild(e);
        };
      }
    }, []), n(() => {
      const e = o.current;
      e && s && e.open !== i && (i ? p ? () => e.showModal() : () => e.show() : () => e.close())();
    }, [s, i, o, p]), /*#__PURE__*/e.createElement("dialog", l({}, f, {
      ref: o,
      onCancel: e => {
        e.preventDefault(), u(e, o.current);
      },
      onClose: e => {
        m(e, o.current);
      }
    }), r);
  });
i.defaultProps = {
  onClose: () => {},
  onCancel: () => {}
};
const s = t => {
    const d = o(),
      [a, s] = r();
    return n(() => {
      const e = d.current;
      if (a || !e) return;
      let n = !0;
      return (c() ? Promise.resolve() : import("dialog-polyfill")).then(n => {
        n && n.default.registerDialog(e);
      }).catch(e => {}).finally(() => {
        n && s(!0);
      }), () => n = !1;
    }, [d, a]), /*#__PURE__*/e.createElement(i, l({}, t, {
      _rd: a,
      ref: d
    }));
  },
  u = n => /*#__PURE__*/e.createElement(s, l({}, n, {
    _md: !0
  })),
  m = n => /*#__PURE__*/e.createElement(s, l({}, n, {
    _md: !1
  }));
export { m as Dialog, u as Modal };